export default __webpack_public_path__ + "static/auto_logos1-bff11c78aefa842517ee0b8ff9151dd8.png";